import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingVsFull2 = props => (
    <section id="outsourcing-vs-full-section2" className="my pt-5 blue-bg">
        {/* <div className='white-shape'></div> */}
        <Container>
            <p className='mb-5'><Trans i18nKey="services:outsourcingVsFull:section-1.txt" components={{ br: <br /> }} /></p>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingVsFull:section-2.title')}</h2>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingVsFull:section-2.text" components={{ br: <br /> }} />
            </p>
        </Container>
    </section>
);

export default OutsourcingVsFull2;
